import React, { useState, useEffect } from 'react';
import { RiTrophyLine } from 'react-icons/ri';

const Leagues = () => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  // Set launch date (45 days from now)
  const calculateTimeLeft = () => {
    const launchDate = new Date();
    launchDate.setDate(launchDate.getDate() + 45);
    
    const difference = +new Date(launchDate) - +new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60)
      };
    }

    return timeLeft;
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearTimeout(timer);
  });

  return (
    <div className="min-h-screen bg-gradient-to-br from-primaryTextColor via-primaryTextColor to-primaryBtnHoverColor text-white overflow-hidden mb-12">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-full h-full bg-repeat" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
        }}></div>
      </div>

      <div className="relative z-10 flex flex-col items-center justify-center min-h-screen px-4 py-12">
        <div className="text-center max-w-6xl mx-auto">
          {/* Coming Soon GIF and Leagues Image */}
          <div className="mb-8 flex flex-col md:flex-row items-center justify-center gap-8">
            {/* Coming Soon GIF */}
            <div className="w-full md:w-1/2 max-w-md">
              <div className="bg-gray-800 bg-opacity-50 rounded-2xl p-6 border border-gray-700 shadow-2xl">
                <img 
                  src="https://38.media.tumblr.com/c0633cf8c0fb5f7104e084779de44a01/tumblr_nd6iaupNZA1thij9do1_1280.gif" 
                  alt="Coming Soon" 
                  className="w-full h-64 object-cover rounded-xl"
                />
                <p className="text-lg font-semibold mt-4 tracking-wide text-amber-400">Get Ready for Epic Battles!</p>
              </div>
            </div>

            {/* Leagues Image */}
            <div className="w-full md:w-1/2 max-w-md">
              <div className="bg-gray-800 bg-opacity-50 rounded-2xl p-6 border border-gray-700 shadow-2xl">
                <img 
                  src="https://i.ytimg.com/vi/lpQ6MiIZpLc/maxresdefault.jpg" 
                  alt="Competitive Leagues" 
                  className="w-full h-64 object-cover rounded-xl"
                />
                <p className="text-lg font-semibold mt-4 tracking-wide text-amber-400">Elite Tournaments Await</p>
              </div>
            </div>
          </div>

          {/* Logo/Brand */}
          <div className="mb-8">
            <div className="w-24 h-24 bg-gradient-to-br from-amber-500 to-orange-600 rounded-2xl flex items-center justify-center shadow-lg mx-auto mb-4">
              <RiTrophyLine className="text-white text-4xl" />
            </div>
            <h1 className="text-5xl md:text-6xl font-heading font-bold mb-4 bg-gradient-to-r from-amber-400 to-orange-500 bg-clip-text text-transparent">
              Leagues
            </h1>
            <p className="text-xl md:text-2xl font-subheading text-gray-300">
              Competitive Tournaments & Events
            </p>
          </div>

          {/* Coming Soon Message */}
          <div className="mb-12">
            <h2 className="text-3xl md:text-4xl font-heading font-bold mb-6">
              Elite Competition Coming Soon
            </h2>
            <p className="text-lg md:text-xl text-gray-300 max-w-2xl mx-auto">
              We're preparing an exciting league system where teams and individuals can compete for glory, prizes, and recognition. Get ready to test your skills against the best.
            </p>
          </div>

          {/* Countdown Timer */}
          <div className="mb-12">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-2xl mx-auto">
              <div className="bg-gray-800 bg-opacity-50 rounded-xl p-4 border border-gray-700">
                <div className="text-4xl md:text-5xl font-bold text-amber-400">{timeLeft.days}</div>
                <div className="text-gray-400">Days</div>
              </div>
              <div className="bg-gray-800 bg-opacity-50 rounded-xl p-4 border border-gray-700">
                <div className="text-4xl md:text-5xl font-bold text-amber-400">{timeLeft.hours}</div>
                <div className="text-gray-400">Hours</div>
              </div>
              <div className="bg-gray-800 bg-opacity-50 rounded-xl p-4 border border-gray-700">
                <div className="text-4xl md:text-5xl font-bold text-amber-400">{timeLeft.minutes}</div>
                <div className="text-gray-400">Minutes</div>
              </div>
              <div className="bg-gray-800 bg-opacity-50 rounded-xl p-4 border border-gray-700">
                <div className="text-4xl md:text-5xl font-bold text-amber-400">{timeLeft.seconds}</div>
                <div className="text-gray-400">Seconds</div>
              </div>
            </div>
          </div>

          {/* Additional Info */}
          <div className="bg-gray-800 bg-opacity-30 rounded-2xl p-6 border border-gray-700 max-w-4xl mx-auto">
            <h3 className="text-2xl font-bold mb-4 text-amber-400">What to Expect</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
              <div className="text-center">
                <div className="w-12 h-12 bg-amber-500 rounded-full flex items-center justify-center mx-auto mb-2">
                  <span className="text-white font-bold">🏆</span>
                </div>
                <p className="font-semibold">Premium Tournaments</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 bg-amber-500 rounded-full flex items-center justify-center mx-auto mb-2">
                  <span className="text-white font-bold">💰</span>
                </div>
                <p className="font-semibold">Cash Prizes</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 bg-amber-500 rounded-full flex items-center justify-center mx-auto mb-2">
                  <span className="text-white font-bold">⭐</span>
                </div>
                <p className="font-semibold">Ranking System</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Leagues;








// import React, { useState, useEffect } from 'react';
// import { RiTrophyLine } from 'react-icons/ri';

// const Leagues = () => {
//   const [timeLeft, setTimeLeft] = useState({
//     days: 0,
//     hours: 0,
//     minutes: 0,
//     seconds: 0
//   });

//   // Set launch date (45 days from now)
//   const calculateTimeLeft = () => {
//     const launchDate = new Date();
//     launchDate.setDate(launchDate.getDate() + 45);
    
//     const difference = +new Date(launchDate) - +new Date();
//     let timeLeft = {};

//     if (difference > 0) {
//       timeLeft = {
//         days: Math.floor(difference / (1000 * 60 * 60 * 24)),
//         hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
//         minutes: Math.floor((difference / 1000 / 60) % 60),
//         seconds: Math.floor((difference / 1000) % 60)
//       };
//     }

//     return timeLeft;
//   };

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setTimeLeft(calculateTimeLeft());
//     }, 1000);

//     return () => clearTimeout(timer);
//   });

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-primaryTextColor via-primaryTextColor to-primaryBtnHoverColor text-white overflow-hidden mb-12">
//       {/* Background Pattern */}
//       <div className="absolute inset-0 opacity-10">
//         <div className="absolute top-0 left-0 w-full h-full bg-repeat" style={{
//           backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
//         }}></div>
//       </div>

//       <div className="relative z-10 flex flex-col items-center justify-center min-h-screen px-4 py-12">
//         <div className="text-center max-w-4xl mx-auto">
//           {/* Logo/Brand */}
//           <div className="mb-8">
//             <div className="w-24 h-24 bg-gradient-to-br from-amber-500 to-orange-600 rounded-2xl flex items-center justify-center shadow-lg mx-auto mb-4">
//               <RiTrophyLine className="text-white text-4xl" />
//             </div>
//             <h1 className="text-5xl md:text-6xl font-heading font-bold mb-4 bg-gradient-to-r from-amber-400 to-orange-500 bg-clip-text text-transparent">
//               Leagues
//             </h1>
//             <p className="text-xl md:text-2xl font-subheading text-gray-300">
//               Competitive Tournaments & Events
//             </p>
//           </div>

//           {/* Coming Soon Message */}
//           <div className="mb-12">
//             <h2 className="text-3xl md:text-4xl font-heading font-bold mb-6">
//               Elite Competition Coming Soon
//             </h2>
//             <p className="text-lg md:text-xl text-gray-300 max-w-2xl mx-auto">
//               We're preparing an exciting league system where teams and individuals can compete for glory, prizes, and recognition. Get ready to test your skills against the best.
//             </p>
//           </div>

//           {/* Countdown Timer */}
//           <div className="mb-12">
//             <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-2xl mx-auto">
//               <div className="bg-gray-800 bg-opacity-50 rounded-xl p-4 border border-gray-700">
//                 <div className="text-4xl md:text-5xl font-bold text-amber-400">{timeLeft.days}</div>
//                 <div className="text-gray-400">Days</div>
//               </div>
//               <div className="bg-gray-800 bg-opacity-50 rounded-xl p-4 border border-gray-700">
//                 <div className="text-4xl md:text-5xl font-bold text-amber-400">{timeLeft.hours}</div>
//                 <div className="text-gray-400">Hours</div>
//               </div>
//               <div className="bg-gray-800 bg-opacity-50 rounded-xl p-4 border border-gray-700">
//                 <div className="text-4xl md:text-5xl font-bold text-amber-400">{timeLeft.minutes}</div>
//                 <div className="text-gray-400">Minutes</div>
//               </div>
//               <div className="bg-gray-800 bg-opacity-50 rounded-xl p-4 border border-gray-700">
//                 <div className="text-4xl md:text-5xl font-bold text-amber-400">{timeLeft.seconds}</div>
//                 <div className="text-gray-400">Seconds</div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Leagues;